import Modal from "react-bootstrap/Modal";
import React, {useState} from "react";

const ModalAddType = ({show, onHide, save}) => {

    const [name, setName] = useState('')

    return (
        <Modal
            show={ show }
            onHide={ () => {
                onHide(false);
            } }
            centered>
            <Modal.Body className={'pb-0'}>
                <h4 className={'mb-0'}>Tambah Tipe</h4>
            </Modal.Body>
            <Modal.Body>
                <div className='form-group'>
                    <input
                        type='text'
                        className='form-control'
                        placeholder='Nama Tipe'
                        onChange={ (e) => setName(e.target.value) }
                        value={name}
                    />
                </div>
                <button
                    className='btn btn-success'
                    onClick={ () => {
                        save(name)
                        setName('')
                    } }>
                    Simpan
                </button>
            </Modal.Body>
        </Modal>
    )
}

export default ModalAddType